import React, { useContext, useEffect, useState } from "react";
import { Container, FormGroup, Label } from "reactstrap";
import { showTopbarInsideAction } from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import HeaderDefaultToPage from "../../../components/Common/headerDefaultToPage";
import NotificationModal from "../../../components/Common/NotificationModal";
import InputSelectCustom from "../../../components/Common/InputSelectCustom";
import { editProfile } from "../../../store/auth/profile/actions";
import { useCookies } from "react-cookie";
import { Skeleton } from "primereact/skeleton";
import InputMask from "react-input-mask";
import { CardGridCustom } from "../../../components/Common/CardGridCustom";
import { InputDateGroup } from "../../../components/Common/InputDateGroup";
import { COLEGAS } from "../../../helpers/routes_helper";
import { fnGetValueByKey } from "../../../helpers/functions";
import { AuthProtectedContext } from "../../../Routes/AuthProtectedContext";
import ImageUploadDynamic from "../../../components/Common/Avatar/ImageUploadDynamic";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";
import ComboBoxAutomatic from "../../../components/Dynamic/ComboBoxAutomatic";

const BI_WS0003 = () => {
  document.title = "Defender | Meus dados";

  const { transactionData } = useContext(AuthProtectedContext);

  const dispatch = useDispatch();
  const { profileState, userProfile, isIframePage, userFull } = useSelector((state) => ({
    profileState: state.profile,
    userProfile: state.login.profile,
    userFull: state.login.user,
    isIframePage: state.Layout.isIframePage
  }));

  const [profileImage, setProfileImage] = useState(userProfile.Foto_Usuario);

  const _csrf = useGetCsrfToken();

  const [loading, setLoading] = useState(true);

  const [originalCpf, setOriginalCpf] = useState("");

  const [inputs, setInputs] = useState({
    Cultura_Idioma: "",
    CPF: "",
    Nome_Completo: "",
    Apelido: "",
    Email: "",
    Data_Nascimento: "",
    Celular: "",
    Telefone: "",
    Departamento: "",
    ID_Departamento: "",
    Cargo: "",
    ID_Cargo: "",
    ID_Idioma: "",
    Foto_Usuario: "",
  });

  const [departamentos, setDepartamentos] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [idiomas, setIdiomas] = useState([]);
  const [colegas, setColegas] = useState([]);

  const [notif, setNotif] = useState({
    isOpen: false,
    isReload: false,
    type: "success",
    message: "",
  });

  const handleData = (data) => {
    try {
      const resultset_1 =
        JSON.parse(data?.find((item) => item?.Resultset === 1)?.Conteudo)[0] ||
        [];
      const resultset_2 =
        JSON.parse(data?.find((item) => item?.Resultset === 2)?.Conteudo) ||
        [];
      const resultset_3 =
        JSON.parse(data?.find((item) => item?.Resultset === 3)?.Conteudo) ||
        [];
      const resultset_4 =
        JSON.parse(data?.find((item) => item?.Resultset === 4)?.Conteudo) ||
        [];
      const resultset_5 =
        JSON.parse(data?.find((item) => item?.Resultset === 5)?.Conteudo) ||
        [];

      const nascimentoRaw = resultset_1.Data_Nascimento || "";
      const isoDate = nascimentoRaw.split("/").reverse().join("-");

      const rawCpf = (resultset_1.CPF || "")?.replace(/\D/g, "");
      const formattedCpf =
        rawCpf.length === 11
          ? rawCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")
          : rawCpf;

      resultset_1.CPF = formattedCpf;

      setInputs({
        Cultura_Idioma: resultset_1.Cultura_Idioma.trim(),
        CPF: resultset_1.CPF.trim(),
        Nome_Completo: resultset_1.Nome_Completo,
        Apelido: resultset_1.Apelido,
        Email: resultset_1.Email,
        Data_Nascimento: isoDate,
        Celular: resultset_1.Telefone_Celular,
        Telefone: resultset_1.Telefone,
        Departamento: resultset_1.Departamento,
        ID_Departamento: resultset_1.ID_Departamento,
        Cargo: resultset_1.Cargo,
        ID_Cargo: resultset_1.ID_Cargo,
        ID_Idioma: resultset_1.ID_Idioma,
        Foto_Usuario: resultset_1.Foto_Usuario,
      });

      setOriginalCpf(resultset_1.CPF.trim());

      setDepartamentos(
        resultset_2?.map((d) => ({
          ID_Departamento: d.ID_Departamento,
          Descricao: d.Descricao_Departamento,
        }))
      );
      setCargos(
        resultset_3?.map((c) => ({
          ID_Cargo: c.ID_Cargo,
          Descricao: c.Descricao_Cargo,
        }))
      );
      setIdiomas(
        resultset_4?.map((i) => ({
          ID_Idioma: i.ID_Idioma,
          Cultura_Idioma: i.Descricao,
        }))
      );

      setColegas(
        resultset_5?.map((i) => ({
          id: i.ID_Usuario,
          avatar: i.Foto_Usuario,
          nome: i.Nome_Completo,
          cargo: i.Cargo,
        }))
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let data = fnGetValueByKey(transactionData, "PROCEDURE_RESULTSET");
    try {
      data = JSON.parse(data);
      handleData(data);
    } catch (error) {
      console.warn("Erro ao parsear PROCEDURE_RESULTSET:", error);
    }
  }, [transactionData]);

  useEffect(() => {
    dispatch(showTopbarInsideAction({}));
  }, [dispatch]);

  useEffect(() => {
    if (profileState.success) {
      setNotif({
        isOpen: true,
        type: "success",
        message: profileState.success,
      });
    }
  }, [profileState.success]);

  useEffect(() => {
    if (profileState.error) {
      setNotif({ isOpen: true, type: "error", message: profileState.error });
    }
  }, [profileState.error]);

  const handleSubmit = (e) => {
    e.preventDefault();

    const raw = inputs.Celular?.replace(/^\+55/, "");
    const digits = raw?.replace(/\D/g, "");

    if (digits?.length !== 11) {
      setNotif({
        isOpen: true,
        type: "error",
        message: "Por favor, preencha o campo Celular.",
      });
      return;
    }

    const formattedDate = inputs.Data_Nascimento.includes("-")
      ? inputs.Data_Nascimento.split("-").reverse().join("/")
      : inputs.Data_Nascimento;

    dispatch(
      editProfile({
        ID_Usuario: userProfile.ID_Usuario,
        Cultura_Idioma: inputs.Cultura_Idioma,
        Nome_Completo: inputs.Nome_Completo,
        Apelido: inputs.Apelido,
        Email: inputs.Email,
        Celular: inputs.Celular,
        Telefone: inputs.Telefone,
        CPF: inputs.CPF,
        Data_Nascimento: formattedDate,
        ID_Departamento: inputs.ID_Departamento,
        ID_Cargo: inputs.ID_Cargo,
        ID_Idioma: inputs.ID_Idioma,
        _csrf: _csrf,
        _access_token_msman: userFull.access_token,
      })
    );
  };

  const handleClose = (isReload) => {
    if (isReload) window.location.reload();
    else setNotif((s) => ({ ...s, isOpen: false }));
  };

  const departamentosOptions = departamentos.map((d) => ({
    label: d.Descricao,
    value: d.ID_Departamento,
  }));
  const cargosOptions = cargos.map((c) => ({
    label: c.Descricao,
    value: c.ID_Cargo,
  }));
  const idiomasOptions = idiomas.map((i) => ({
    label: i.Cultura_Idioma,
    value: i.ID_Idioma,
  }));

  const selectedDepartamento =
    departamentosOptions.find((o) => o.value === inputs.ID_Departamento) ||
    null;
  const selectedCargo =
    cargosOptions.find((o) => o.value === inputs.ID_Cargo) || null;
  const selectedIdioma =
    idiomasOptions.find((o) => o.value === inputs.ID_Idioma) || null;

  return (
    <>
      <NotificationModal
        isOpen={notif.isOpen}
        type={notif.type}
        message={notif.message}
        titleCustom={notif.titleCustom}
        onClose={() => handleClose(notif?.isReload)}
      />

      <div className={`page-content page-config ${isIframePage && "is-iframe-content"}`}>
        <Container fluid className="dataTable-custom-primary">
          <HeaderDefaultToPage goBackPage="/BI_WS0002" title="Meus Dados" />

          <div className="row p-0 m-0">
            {loading ? (
              <Skeleton width="100%" height={550} />
            ) : (
              <>
                <div
                  style={{ height: "fit-content" }}
                  className="col-md-5 col-lg-3 col-xxl-2 col-sm-12 ps-0 d-flex flex-column skeleton-div"
                >
                  <div className="bg-white mb-3 card-content shadow-card ">
                    <div className=" p-4 avatar-wrapper position-relative d-flex flex-column align-items-center justify-content-center text-center">
                      <ImageUploadDynamic
                        src={profileImage}
                        alt={userProfile.Nome_Completo}
                        width={150}
                        router={`/BI_WS0037A?ID=${userProfile.ID_Usuario}&modal=true`}
                        onClosed={(obj) => {
                          setNotif(obj);
                          if(obj?.publicUrl){
                            setProfileImage(obj.publicUrl);
                          }
                        }}
                      />

                      <p className="username font-size-24 font-w-600 text-primary-dark mb-0 mt-3">
                        {inputs.Nome_Completo}
                      </p>
                    </div>
                  </div>

                  {colegas.length > 0 && (
                    <div className="bg-white card-content d-flex flex-column flex-fill shadow-card">
                      <div className="card-body overflow-auto p-3 px-3">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                          <p className="m-0 font-size-16 font-w-600 text-color-azul1 titulo-colegas">
                            Meus colegas
                          </p>
                          <a
                            href={COLEGAS}
                            className="small font-size-14 text-color-azul4 text-decoration-underline"
                          >
                            Ver mais
                          </a>
                        </div>

                        <ul className="list-unstyled mb-0 overflow-auto">
                          {colegas.map((c, idx) => {
                            let avatar = JSON.parse(c.avatar)[0];
                            return (
                              <li
                                key={idx}
                                className={`d-flex align-items-center gap-2 ${
                                  colegas.length - 1 !== idx ? "mb-3" : ""
                                }`}
                              >
                                {avatar.valor !== "[]" ? (
                                  <img
                                    src={avatar.valor || ""}
                                    className="rounded-circle avatar-colegas"
                                    style={{
                                      width: 32,
                                      height: 32,
                                      objectFit: "cover",
                                    }}
                                    alt={avatar.descricao}
                                  />
                                ) : (
                                  <i
                                    className="far fa-user-circle user-photo-label me-2"
                                    style={{ fontSize: 32 }}
                                    aria-hidden="true"
                                  />
                                )}
                                <div>
                                  <div className="m-0 fw-semibold font-size-12 font-w-500">
                                    {avatar.descricao}
                                  </div>
                                  {avatar.cargo && (
                                    <div className="div-cargo-colega">
                                      <small className="text-muted m-0 cargo-colega font-size-10">
                                        {avatar.cargo}
                                      </small>
                                    </div>
                                  )}
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-md-7 col-lg-9 col-sm-12 col-xxl-10 dados-pessoais ">
                  <div className="px-2 shadow-card bg-white">
                    <CardGridCustom
                      title=""
                      paddingTitle="py-3 pb-4"
                      className="text-color-azul1"
                    >
                      <h5 className="m-0 font-size-20 font-w-600 text-color-azul1 mb-3 mt-3">
                        {" "}
                        Dados pessoais
                      </h5>
                      <form
                        className="row form-default-primary"
                        onSubmit={handleSubmit}
                      >
                        {/* linha 1 */}
                        <div className="col-6 mb-3">
                          <Label>Nome Completo*</Label>
                          <input
                            type="text"
                            className="form-control"
                            value={inputs.Nome_Completo}
                            onChange={(e) =>
                              setInputs((s) => ({
                                ...s,
                                Nome_Completo: e.target.value,
                              }))
                            }
                          />
                        </div>
                        <div className="col-3 mb-3">
                          <Label>Nome de exibição</Label>
                          <input
                            type="text"
                            className="form-control"
                            value={inputs.Apelido}
                            onChange={(e) =>
                              setInputs((s) => ({
                                ...s,
                                Apelido: e.target.value,
                              }))
                            }
                          />
                        </div>

                        <div className="col-3 mb-3">
                          <label htmlFor="dtNascimento" className="form-label">
                            Data de Nascimento*
                          </label>
                          <InputDateGroup
                            id="dtNascimento"
                            value={inputs.Data_Nascimento}
                            onChange={(e) =>
                              setInputs((s) => ({
                                ...s,
                                Data_Nascimento: e.target.value,
                              }))
                            }
                            placeholder="dd/mm/aaaa"
                          />
                        </div>

                        {/* linha 2 */}
                        <div className="col-6 mb-3">
                          <Label>E‑mail / Login*</Label>
                          <input
                            disabled
                            type="email"
                            className="form-control"
                            value={inputs.Email}
                            onChange={(e) =>
                              setInputs((s) => ({
                                ...s,
                                Email: e.target.value,
                              }))
                            }
                          />
                        </div>

                        <div className="col-3 mb-3">
                          <Label>CPF*</Label>
                          <InputMask
                            mask="999.999.999-99"
                            maskChar={null}
                            alwaysShowMask={false}
                            value={inputs.CPF}
                            disabled={Boolean(originalCpf)}
                            onChange={(e) =>
                              setInputs((s) => ({ ...s, CPF: e.target.value }))
                            }
                            className="form-control"
                            style={
                              originalCpf
                                ? {
                                    backgroundColor: "#e9ecef",
                                    color: "#6c757d",
                                    cursor: "not-allowed",
                                  }
                                : undefined
                            }
                          />
                        </div>

                        <div className="col-3">
                          <FormGroup>
                            <Label>Idioma</Label>
                            <InputSelectCustom
                              name="idioma"
                              optionsData={idiomasOptions}
                              stateSelected={selectedIdioma}
                              placeholder="Selecione..."
                              handleOnChange={(opt) =>
                                setInputs((s) => ({
                                  ...s,
                                  ID_Idioma: opt.value,
                                  Cultura_Idioma: opt.label,
                                }))
                              }
                            />
                          </FormGroup>
                        </div>

                        {/* linha 3 */}
                        <div className="col-6 mb-3">
                          <Label>Celular*</Label>
                          <div className="input-group">
                            <InputMask
                              mask="(99) 9 9999-9999"
                              value={inputs.Celular?.replace(/^\+55/, "")}
                              className="form-control"
                              onChange={(e) =>
                                setInputs((s) => ({
                                  ...s,
                                  // sempre armazena com +55
                                  Celular: "+55" + e.target.value,
                                }))
                              }
                            />
                          </div>
                        </div>

                        <div className="col-6 mb-3">
                          <Label>Telefone</Label>
                          <div className="input-group">
                            <InputMask
                              mask="(99) 9999-9999"
                              value={inputs.Telefone?.replace(/^\+55/, "")}
                              className="form-control"
                              onChange={(e) =>
                                setInputs((s) => ({
                                  ...s,
                                  Telefone: "+55" + e.target.value,
                                }))
                              }
                            />
                          </div>
                        </div>
                        {/* linha 4 */}                        
                        <div className="col-6 mb-0">
                          {departamentosOptions.length > 0 ? (                          
                              <FormGroup>
                                <ComboBoxAutomatic 
                                  titulo={"Departamento"}
                                  name="departamento"
                                  dataOptions={departamentosOptions}
                                  initialValue={selectedDepartamento}
                                  placeholder="Selecione..."
                                  handleOnChange={(opt) =>
                                    setInputs((s) => ({
                                      ...s,
                                      ID_Departamento: opt.value,
                                      Departamento: opt.label,
                                    }))
                                  }
                                />
                              </FormGroup>
                          ) : <Skeleton className="mb-3" width="100%" height={70}></Skeleton>}
                        </div>
                        <div className="col-6 mb-0">
                        {cargosOptions.length > 0 ? (                          
                            <FormGroup className="w-100">
                              <ComboBoxAutomatic 
                                titulo={"Cargo"}
                                name="cargo"
                                dataOptions={cargosOptions}
                                initialValue={selectedCargo}
                                placeholder="Selecione..."
                                handleOnChange={(opt) =>
                                  setInputs((s) => ({
                                    ...s,
                                    ID_Cargo: opt.value,
                                    Cargo: opt.label,
                                  }))
                                }
                              />
                            </FormGroup>
                        ) : <Skeleton className="mb-3" width="100%" height={70}></Skeleton>}
                        </div>
                        {/* botão */}
                        <div className="col-9 d-flex justify-content-end"></div>
                        <div className="col-3 d-flex justify-content-end">
                          <button
                            type="submit"
                            style={{ height: 52 }}
                            className="btn w-100 font-w-600 bg-primary-dark border-0 mb-1 text-white px-4 btn-hover-primary"
                          >
                            Salvar alterações
                          </button>
                        </div>
                      </form>
                    </CardGridCustom>
                  </div>
                </div>
              </>
            )}
          </div>
        </Container>
      </div>
    </>
  );
};

export default BI_WS0003;
